<div class="page-container page-containers content-w-98">
  <div class="page-head">
    <div>
      <div class="page-title">
        <span class="headerName">{{ headerData!.materialName }}</span>
      </div>
    </div>
  </div>
  <div>
    <div>
      <div class="row">
        <div
          class="col-md-12"
          *ngrxLet="{
            dataLoaded: (sharedFacade.isLoaded$ | async),
            isClearSearch: (sharedFacade.isClearSearch$ | async)
          } as sharedData"
        >
          <ng-container *ngrxLet="projectFacade.getProductIngredient$ as getProductIngredient">
            <piqet-angular-portlet
              [columnDefs]="columnDefs"
              [frameworkComponents]="frameworkComponents"
              [headerBtn]="
                getProductIngredient?.length > 0
                  ? 'Edit product ingredients'
                  : 'Add product ingredients'
              "
              [gridData]="getProductIngredient"
              [createAccess]="showEdit"
              (openBtnModal)="addIngredientModal(getProductIngredient[0]?.ingredientId)"
              [class]="'fixedHeight'"
              [searchInputSize]="true"
              (paginationChangeEvent)="paginationChanged($event)"
              (searchEvent)="searchMaterial($event)"
              (sortChangeEvent)="sortChanged($event)"
              [isClearSearch]="sharedData.isClearSearch"
              [gridName]="gridName"
            ></piqet-angular-portlet>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-start">
    <button type="button" class="btn back-btn modelBtn" (click)="backRoute()">
      <i class="bi bi-arrow-left checkboxLeft-div"></i> Back
    </button>
    <button type="button" (click)="nextRoute()" class="next-btn modelBtn">
      {{ backBtnLabel }}<i class="bi bi-arrow-right checkbox-div"></i>
    </button>
  </div>
</div>
